export default "__VITE_ASSET__77d2cd07__"